<template lang="pug">
  .activated-select
    .activated-select__checkbox
      label.checkbox
        input.checkbox__input(
        type="checkbox"
        v-model="fields.checkbox"
        @change="$emit('checkbox-change', checkboxField, fields.checkbox)"
        )
        .checkbox__icon
    .activated-select__select
      multiselect.custom-multiselect(
      v-model="fields.select"
      :placeholder="placeholder",
      :options="localOptions"
      :label="label"
      :track-by="trackBy",
      :multiple="multiple"
      :showLabels="showLabels"
      :closeOnSelect="closeOnSelect"
      :allowEmpty="allowEmpty"
      :disabled="!fields.checkbox"
      @select="onSelect"
      @input="onInput"
      )
        template(
        slot="noOptions"
        ) Список пуст
        template(
        slot="noResult"
        )  Ничего не найдено
        template(
        slot="selection"
        slot-scope="{ values, search, isOpen }"
        )
          span.multiselect__single(v-if="values.length && !isOpen")
            | {{ setAreaMultiselectVal(values) }}
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "ActivatedSelect",
  components: {
    Multiselect
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: [Array, Object],
      default: null
    },
    label: {
      type: String,
      default: "name"
    },
    trackBy: {
      type: String,
      default: "id"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    checkboxValue: {
      type: Boolean,
      default: false
    },
    checkboxField: {
      type: String,
      default: ""
    },
    selectValue: {
      type: Array,
      default: () => ([])
    },
    selectField: {
      type: String,
      default: ""
    }
  },
  computed: {
    localOptions() {
      if (!this.options) {
        return [];
      }
      return this.options;
    }
  },
  data() {
    return {
      fields: {
        checkbox: false,
        select: null
      }
    };
  },
  methods: {
    setAreaMultiselectVal(val) {
      if (val.length > 1) {
        return "Выбрано " + val.length;
      }
      return val[0][this.label];
    },
    onSelect(val) {
    },
    onInput(val) {
      this.$emit("select-change", this.selectField, val);
    },
    setFields() {
      if (this.selectValue.length > 0) {
        this.fields.select = this.selectValue;
      }
      this.fields.checkbox = this.checkboxValue;
    }
  },
  created() {
    this.setFields();
  },
  watch: {
    selectValue() {
      this.setFields();
    },
    checkboxValue() {
      this.setFields();
    }
  }
};
</script>
